export default {"src":"/_next/static/media/chevronRightUiLight_24.460bd161.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};